module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ab102-661277a7fafa95a49aa4ca65056c6b40.jpg";